<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">
      <header id="scrn-h">
        <div class="myunichoices-logo">
          <a routerLink="/login">
            <img src="assets/images/myunichoices-logo.png" alt="" />
          </a>
        </div>
        <div class="subtitle-strap">
          {{ locale.introText }}
        </div>
      </header>
      <form
        id="scrn-c"
        [formGroup]="resendActivationForm"
        (ngSubmit)="resendActivation(resendActivationForm.value)"
        novalidate="novalidate"
      >
        <div class="form-header">
          <div ngxBalanceText>
            {{ locale.subtitleText }}
          </div>
        </div>
        <div class="form-control">
          <input
            type="email"
            class="input-control"
            placeholder="Email address"
            [formControl]="resendActivationForm.controls['email']"
          />
          <div
            class="validation-error"
            *ngIf="
              (forgottenPasswordSubmitted || resendActivationForm.controls['email'].dirty) &&
              !resendActivationForm.controls['email'].valid
            "
            [@fadeInOutHeight]
          >
            <div class="form-hint">
              <div>{{ locale.emailValidationText }}</div>
            </div>
          </div>
        </div>
        <div class="form-control">
          <button type="submit" class="input-control button" [disabled]="formSubmitted">
            {{ locale.continueButtonText }}
          </button>
        </div>
      </form>
      <footer id="scrn-f">
        <div class="sign-up">
          {{ locale.loginText }} <a routerLink="/login">{{ locale.loginLinkText }}</a>
        </div>
      </footer>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/resend-activation/resend-activation.component.html